import { PropType } from 'vue';
import { Options } from 'vue-class-component';
import { BaseSceneSlide, SceneSlideType } from '../SceneSlide.base';
import SceneTimeObject from '../../SceneTimeObject/SceneTimeObject.vue';
import {
  PlantDetailDTO,
  TriggerDTO,
} from '@/../client-generator/generated-clients/plants';

@Options({
  name: 'TriggerSceneSlide',
  props: {
    triggers: {
      type: Array.of(Object as PropType<TriggerDTO>),
      required: true,
    },
    plant: {
      type: Object as PropType<PlantDetailDTO>,
    },
  },
  components: {
    SceneTimeObject,
  },
})
export default class TriggerSceneSlide extends BaseSceneSlide {
  plant!: PlantDetailDTO;
  triggers: TriggerDTO[] = [];
  slideType = SceneSlideType.TRIGGER;

  mounted() {
    this.items = this.triggers;
    this.$nextTick(() => super.inferSlideType());
  }

  unmounted() {
    super.unmounted();
  }
}
